import { GeofenceRequestType, GroupRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * saveGroupByCustomerAndDepartment - Function that saves on database a new group by department   
 * /groups  
 * method POST  
 * @async-function
 */
const saveGroupByCustomerAndDepartment = async (token: string, model: GroupRequestType) => {
    const response = await api.post(
        `/groups`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default saveGroupByCustomerAndDepartment;